export const nodalForDetailsProyect = {
	projects: "projects",
	workTeam: "workTeam",
	client: "client",
	calendar: "calendar",
	pauses: "pauses",
	hrsProjectDetails: "hrsProjectDetails",
	hrsExtraResource: "hrsExtraResource",
	hrsExtraTime: "hrsExtraTime",
	updateHrs: "updateHrs",
	reactivePause: "reactivePause",
	cancelarProyect: "cancelarProyect",
	continueCancelarProyect: "continueCancelarProyect",
	finishProjectDate: "finishProjectDate",
	concluedProject: "concluedProject",
	projectRed: "projectRed",
	viewConcluedProject: "viewConcluedProject",
	updateTimeConclued: "updateTimeConclued",
	modalDebugTaskCount: "modalDebugTaskCount",
};

export const actionMethod = {
	deleteExtraResoruce: "deleteExtraResoruce",
	deleteExtraTime: "deleteExtraTime",
	deleteAdjustmentOfHours: "deleteAdjustmentOfHours",
};

export const typeForDetailsProyect = {
	...nodalForDetailsProyect,
	...actionMethod,
};
